<template>
    <span class="day-tag">
      <p class="inner-tag-text"><slot></slot></p>
    </span>
  </template>

  <script>
  export default {
      name: "ActivityTag"
  }
  </script>


  <style lang="scss" scoped>
  .day-tag {
      color: #f4a13c !important;
      background: #FFFFFF;
      border-radius: 6px;
      padding: 4px 6px;
      padding-top: 5px;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 19px;
      text-align: center;
      text-transform: capitalize;
      border: 1px solid #f4a13c !important;
      margin-bottom: 4px;
      margin-right: 4px;
      display: inline-block;
			// cursor: pointer;
      .inner-tag-text {
          text-align: center;
      }
  }
  </style>
